import React, { useEffect, useState, Suspense } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useNavigate } from 'react-router-dom';
import { getApi } from '../../../Services/apiService';
import Modal from 'react-modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Import CSS for DatePicker
import UserManagement from "../User Management/dashboard";
import DeleteModal from "../../SharedComponents/deleteModal";

// Register chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const Subscription = () => {
  const [selectedDate, setSelectedDate] = useState(new Date()); // Default to today's date
  const [monthlyUsers, setMonthlyUsers] = useState(50); // Default monthly data
  const [monthlyActiveUsers, setMonthlyActiveUsers] = useState(30); // Default monthly data
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null); // New state for storing selected user ID
  const [totalAllTimeActiveUsers, setTotalAllTimeActiveUsers] = useState(null); 
  const [totalAllTimeInActiveUsers, setTotalAllTimeInActiveUsers] = useState(null); 
  const [totalMonthlyActiveUsers, setTotalMonthlyActiveUsers] = useState(null); 
  const [totalMonthlyInActiveUsers, setTotalMonthlyInActiveUsers] = useState(null); 

  // Handle date change
  const handleDateChange = (date) => {
    setSelectedDate(date);

    // Extract month and year from the selected date
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");

    // Call fetchUsers with the selected month and year
    fetchUsers(query, month, year);
  };

  const pieData1 = {
    labels: [
      `Total Users (${totalAllTimeActiveUsers + totalAllTimeInActiveUsers})`, 
      `Active Users (${totalAllTimeActiveUsers})`, 
      `Inactive Users (${totalAllTimeInActiveUsers})`
    ],
    datasets: [
      {
        data: [totalAllTimeActiveUsers, totalAllTimeInActiveUsers],
        backgroundColor: ["#36A2EB", "#FF6384"],
        hoverBackgroundColor: ["#36A2EB", "#FF6384"],
      },
    ],
  };

  const pieData2 = {
    labels: [
      `Total Users (${totalMonthlyActiveUsers + totalMonthlyInActiveUsers})`, 
      `Active Users (${totalMonthlyActiveUsers})`, 
      `Inactive Users (${totalMonthlyInActiveUsers})`
    ],
      datasets: [
      {
        data: [totalMonthlyActiveUsers, totalMonthlyInActiveUsers],
        backgroundColor: ["#4BC0C0", "#FF9F40"],
        hoverBackgroundColor: ["#4BC0C0", "#FF9F40"],
      },
    ],
  };

  const fetchUsers = async (query = '', month = null, year = null) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getApi(`/admin/get-subscription-data?search=${query}&month=${month}&year=${year}`);
      if (response && response.statusCode === 200) {
        setUsers(response?.data || []);
        setTotalAllTimeActiveUsers(response?.data?.allTime?.activeCount);
        setTotalAllTimeInActiveUsers(response?.data?.allTime?.inactiveCount);
        setTotalMonthlyActiveUsers(response?.data?.currentMonth?.activeCount);
        setTotalMonthlyInActiveUsers(response?.data?.currentMonth?.inactiveCount);
      } else {
        throw new Error('Failed to fetch users.');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial fetch when the component loads
    const year = selectedDate.getFullYear();
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, "0");
    fetchUsers(query, month, year);
  }, [query, editUserModal, deleteModal]);

  const openModal = (selectedUser) => {
    setSelectedUserId(selectedUser);
    setEditUserModal(true);
  };

  const openDeleteUserModal = (id) => {
    setSelectedUserId(id);
    setDeleteModal(true);
  };

  return (
    <>
        {loading &&  <div className="loader">  <div class="spinner"></div> </div>}
  {error && <p className="error-message">{error}</p>}

<div className={`RightSideDiv subscription-page ${loading ? 'blurred' : ''}`}>

      {/* Date Picker */}
      

      {/* Pie Charts */}
      <div className="charts-container">
        <div className="row">
          <div className="col-sm-6">
            <div className="chart">
              <h4>Total Users Overview</h4>
              {(totalAllTimeActiveUsers || totalAllTimeInActiveUsers) ? (
          <Pie data={pieData1} />
        ) : (
          <p className="no-data-message">No data available for total users.</p>
        )}            </div>
          </div>

          <div className="col-sm-6">
            <div className="chart">
            <div className="date-picker-container">
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="yyyy-MM" // Display only year and month
          showMonthYearPicker // Enables month and year view
          className="form-control"
          onKeyDown={(e) => e.preventDefault()} // Blocks manual typing

        />
      </div>
              <h4>
                Users in {selectedDate.toLocaleString("default", { month: "long" })}{" "} 
                {selectedDate.getFullYear()}
              </h4>
              {(totalMonthlyActiveUsers || totalMonthlyInActiveUsers) ? (
          <Pie data={pieData2} />
        ) : (
          <p className="no-data-message">No data available for this month.</p>
        )}
            </div>
          </div>
        </div>
      </div>

      <UserManagement />
      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isOpen={deleteModal}
          onRequestClose={() => setDeleteModal(false)}
          contentLabel="Delete Modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add-category delete logout `}
          portalClassName="add-user delete"
        >
          <DeleteModal setDeleteModal={setDeleteModal} userDetails={selectedUserId} title={'this user'} comp={'user'} />
        </Modal>
      </Suspense>
    </div>
    </>
  );
};

export default Subscription;
